import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/firestore'
import '@firebase/storage'
import firebaseConfig from '../firebase.config'

firebase.initializeApp(firebaseConfig)

const firestore = firebase.firestore()
const settings = { /* your settings... */ timestampsInSnapshots: true }
firestore.settings(settings)

const googleAuth = new firebase.auth.GoogleAuthProvider()
googleAuth.setCustomParameters({
  prompt: 'select_account',
})
export const auth = firebase.auth()
export const googleAuthProvider = googleAuth
export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider()
export const db = firestore
export const storage = firebase.storage()
